 
export function getFacultiesMenuMobileWrapper(callback) {
    $.ajax({
        type: "GET",
        url: tech.core.getInternationalUrl('/Home/GetFacultiesMenuMobileWrapper/' + window.location.pathname.replace(/\//g, '|')),
        dataType: "html",
        success: successFunc,
        error: errorFunc
    });

    function successFunc(data, status) {
        $("#faculties-menu-mobile-wrapper .sidebar").append(data);
        
        if(typeof callback !== "undefined") {
            callback();
        }
    }

    function errorFunc(jQXHR, textStatus, errorThrown) {
        console.log("An error occurred while trying to contact the server: " + jQXHR.status + " " + textStatus + " " + errorThrown);
    }
}

export function getFacultiesMenuDesktopWrapper(callback) {
    $.ajax({
        type: "GET",
        url: tech.core.getInternationalUrl('/Home/GetFacultiesMenuDesktopWrapper/' + window.location.pathname.replace(/\//g, '|')),
        dataType: "html",
        success: successFunc,
        error: errorFunc
    });

    function successFunc(data, status) {
        $("#faculties-menu-desktop-wrapper #tech-navigation").append(data);
        
        if(typeof callback !== "undefined") {
            callback();
        }
    }

    function errorFunc(jQXHR, textStatus, errorThrown) {
        console.log("An error occurred while trying to contact the server: " + jQXHR.status + " " + textStatus + " " + errorThrown);
    }
}